import { oAuth } from '@/classes/Auth';

export function hasPermission(param: string){
    if(oAuth.getModules()){
        return oAuth.getModules().includes(param);
    }
    return false;
}